import { addValidationRule } from 'formsy-react';
import dayjs from 'dayjs';
let rulesAdded = false;
function isPhone(values, value) {
  // custom validation must handle 'not required' case
  if (!value) return true;
  const regex = /^[+]?[(]?[0-9]{3}[)]?[-\s.,]?[0-9]{3}[-\s.,]?[0-9]{4,6}$/im;
  return regex.test(value);
}

// Allowing some special characters for punctuation [e.g. ,.!()]
// Disallowing <, >, \, |, ;, %, ^, and \
function isWordsAndSomePunctuation(values, value) {
  const regex = /[<>|;%^*\\]/gm;
  return !regex.test(value);
}

// Allows almost all latin alphabetic characters as well as whitespace and hyphens, but rejects whitespace only inputs
function isValidName(values, value) {
  if (value.length > 0 && value.trim() === '') {
    return false; // Disallow input of only whitespace
  }
  const regex = /[^a-zA-Z\xC0-\xFF\s-]/gm;
  return !regex.test(value);
}
function isNotProfane(values, value) {
  const badwords = ['ass', 'asshole', 'cunt', 'fuck', 'fucker', 'fuckwad', 'fucking', 'fucked', 'fuckhead', 'finger-fuck', 'bitches', 'bitching', 'bitch', 'dipshit', 'shit', 'shitter', 'shitted', 'shithead', 'shitting', 'motherfucker', 'motherfucking', 'badass', 'horseshit', 'bullshit', 'piss', 'pissing', 'pissed', 'anal', 'cock', 'twat', 'penis', 'pussy', 'pussywhipped', 'dickhead', 'dickwad', 'douchebag', 'dammit', 'damnit', 'damn', 'damned', 'damning', 'bastard', 'pissant', 'beastiality', 'blowjob', 'clit', 'clitoral', 'hooters', 'goddamn', 'masturbation', 'masturbate', 'masturbating', 'masturbated', 'cocksucker', 'cocksucking', 'tits', 'boobs', 'cum', 'tight-ass', 'tight-assed', 'poontang', 'putang', 'fuckhole', 'nigger', 'faggot', 'ejaculate', 'orgasm', 'pubic', 'goddammit', 'goddamnit', 'cunnilingus', 'sodomize', 'sodomized', 'sodomizing', 'vulva', 'fellatio', 'fisting', 'whore', 'clit', 'chickenshit', 'asswad', 'jackoff', 'quim', 'transsexual', 'vibrator', 'rectum', 'scrotum', 'semen', 'menstruate', 'menstruated', 'menstruating', 'copulate', 'honkies', 'dildo', 'muffdiver', 'rimjob', 'carjockey', 'allusedcars', 'allusedtrucks', 'motherfuck', 'http', 'www', 'retard', 'retarded'];
  return badwords.every(word => value.toLowerCase().search(new RegExp('\\b' + word + '\\b')) === -1);
}
function isPositive(values, value) {
  return !Number.isNaN(value) && value >= 0;
}
function isWithinRange(values, value, range) {
  const numberValue = parseFloat(value);
  return !(numberValue < range[0] || numberValue > range[1]);
}
function isValidZipExternal(values, value, isValid) {
  return isValid;
}

/**
 * Returns true if value is a number and not zero.
 */
function isIntNotZero(values, value) {
  const regex = /^\d+$/;
  if (!value) return false;
  return regex.test(value);
}

/**
 * Returns true if the value is positive (not zero) and within a specified number of decimal places
 */
function isPositiveDecimal(values, value, decimalPlaces) {
  const regexString = `^(?=.*[1-9])\\d*(\\.\\d{1,${decimalPlaces}})?$`;
  const regex = new RegExp(regexString);
  return !!value && regex.test(value.toString());
}

/**
 * Returns true if the value is positive or zero and within a specified number of decimal places
 */
function isNonNegativeDecimal(values, value, decimalPlaces) {
  const regexString = `^(?=.*[0-9])\\d*(\\.\\d{1,${decimalPlaces}})?$`;
  const regex = new RegExp(regexString);
  return !!value && regex.test(value.toString());
}

/**
         * Returns true if the value is a valid date (date, time) or (time, date)
         */
function isValidDateTime(values, value1, value2) {
  const dateTimeInput = new Date(`${value2} ${value1}`);

  /* eslint-disable-next-line no-restricted-globals */
  if (dateTimeInput instanceof Date && dateTimeInput !== 'Invalid Date' && !isNaN(dateTimeInput)) {
    return true;
  }
  return false;
}
function isFutureDateTime(values, value1, value2) {
  return dayjs().isBefore(dayjs(`${value1} ${value2}`));
}
function isCurrentOrFutureDate(values, value) {
  return dayjs().subtract(1, 'day').isBefore(dayjs(value));
}
function isDateWithin3Months(values, value, _ref) {
  let {
    startDate
  } = _ref;
  return dayjs(value).isBefore(dayjs(startDate).add(3, 'months'));
}
function validateDate(values, value, _ref2) {
  let {
    startDate
  } = _ref2;
  if (!isValidDateTime(values, value)) {
    return 'Please enter a valid date (MM/DD/YYYY).';
  }
  if (!isCurrentOrFutureDate(values, value)) {
    return 'Please choose a date that is not in the past.';
  }
  if (!isDateWithin3Months(values, value, {
    startDate
  })) {
    return 'Please choose a date within the next 3 months.';
  }
  return true;
}
function isDealerOpenDate(values, value, _ref3) {
  let {
    disabledDaysOfWeek,
    nextOpenDate
  } = _ref3;
  if (dayjs(nextOpenDate).subtract(1, 'day').isAfter(dayjs(value))) {
    return false;
  }
  if (disabledDaysOfWeek.length >= 1) {
    return !disabledDaysOfWeek.includes(dayjs(value).day());
  }
  return true;
}
function addValidationRules() {
  if (!rulesAdded) {
    addValidationRule('isPhone', isPhone);
    addValidationRule('isWordsAndSomePunctuation', isWordsAndSomePunctuation);
    addValidationRule('isValidName', isValidName);
    addValidationRule('isNotProfane', isNotProfane);
    addValidationRule('isPositive', isPositive);
    addValidationRule('isWithinRange', isWithinRange);
    addValidationRule('isValidZipExternal', isValidZipExternal);
    addValidationRule('isIntNotZero', isIntNotZero);
    addValidationRule('isPositiveDecimal', isPositiveDecimal);
    addValidationRule('isNonNegativeDecimal', isNonNegativeDecimal);
    addValidationRule('isValidDateTime', isValidDateTime);
    addValidationRule('isFutureDateTime', isFutureDateTime);
    addValidationRule('isCurrentOrFutureDate', isCurrentOrFutureDate);
    addValidationRule('isDateWithin3Months', isDateWithin3Months);
    addValidationRule('validateDate', validateDate);
    addValidationRule('isDealerOpenDate', isDealerOpenDate);
    rulesAdded = true;
  }
}
export default addValidationRules;